import React, { useContext } from 'react';

import ROUTES from '../../../routes';
import CustomCtas from '../../CustomCtas';
import EmailInput from '../../EmailInput';
import Logos from '../../Logos';
import PopSQLLogoMobile from '../../PopSQLLogoMobile';
import Slider from '../../Slider';

import Button from '@components/Button';
import Heading from '@components/Heading';
import { Context } from '@contexts/AppContext';

const Hero = ({
  title = 'Collaborative SQL editor for your team',
  subtitle = 'Write queries, visualize data, and share your results',
  customLogo = false,
  customLogoWidth = false,
  customCta = false,
  disableCustomers = false,
}) => {
  const { isLoggedIn } = useContext(Context);

  return (
    <>
      <div
        style={{ animationDelay: `600ms` }}
        className="container mx-auto flex flex-col items-center py-16 px-6 fade"
      >
        {!customLogo ? (
          <PopSQLLogoMobile className="z-10" />
        ) : (
          <div className="hover:scale-125 transition group flex-col shrink-0 relative group h-10 w-10 sm:h-24 sm:w-24 bg-white rounded-[8px] sm:rounded-[16px] sm:rounded-xl shadow-header-menu flex items-center justify-center border-[0.5px] mb-8">
            <figure className="h-8 w-8 sm:h-12 sm:w-12 flex relative items-center justify-center shrink-0">
              <img
                src={customLogo}
                width={customLogoWidth || 'auto'}
                alt="Logo"
              />
            </figure>
          </div>
        )}

        <div className="z-10">
          <Heading className="text-center" size="lg" Tag="h1">
            {title}
          </Heading>
          <h2 className="text-center max-w-xl mt-4 mx-auto text-gray-600 leading-normal text-md lg:text-xl font-inter font-medium fade fade-2">
            {subtitle}
          </h2>
        </div>

        {isLoggedIn ? (
          <div className="mt-6 md:mt-12 flex flex-col gap-4 text-center max-w-[300px]">
            <Button
              href={ROUTES.appPopSQL}
              className="min-w-[260px]"
              variant="primary"
              hasArrow
            >
              Open app
            </Button>
            <p className="font-inter text-gray-600 font-medium">
              Or get the{' '}
              <a
                className="text-black font-semibold underline underline-offset-4 decoration-pink hover:decoration-pink/50"
                href={ROUTES.download}
              >
                desktop version
              </a>
            </p>
          </div>
        ) : (
          <div
            style={{ minHeight: 100 }}
            className="z-10 flex justify-center flex-col items-center w-full fade fade-3"
          >
            <>
              {customCta ? (
                <CustomCtas link={customCta} />
              ) : (
                <>
                  <EmailInput />
                  <p className="mt-2 text-center text-sm md:text-md font-inter">
                    Available for web, macOS, Windows, and Linux
                  </p>
                </>
              )}
            </>
          </div>
        )}

        {!disableCustomers && (
          <>
            <div className="flex items-center justify-center flex-wrap py-4 z-10 w-screen fade fade-6">
              <Slider duration={15}>
                <Logos />
              </Slider>
              <Slider duration={15}>
                <Logos secondRow />
              </Slider>
            </div>

            <div className="fade fade-5 z-10 flex items-center space-x-6 md:space-x-8 max-w-xl">
              <a href="https://www.g2.com/products/popsql/reviews">
                <img
                  className="w-40"
                  src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/g2-performer-2022.svg`}
                />
              </a>
              <a href="https://www.g2.com/products/popsql/reviews">
                <img
                  className="w-40"
                  src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/g2-performer-2022-fall.svg`}
                />
              </a>
              <a href="https://www.g2.com/products/popsql/reviews">
                <img
                  className="w-40"
                  src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/g2-2023-performer-1.svg`}
                />
              </a>

              <div className="flex flex-col space-y-2 font-inter font-medium text-md text-left">
                <p className="text-gray-400">
                  From startups to enterprises, PopSQL is trusted by 2000+ of
                  the world's top data teams.
                </p>
                <a
                  className="font-semibold hover:text-blue-200"
                  href="/customers"
                >
                  Learn about our customers {`->`}
                </a>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default Hero;
